// @ts-nocheck
/* eslint-disable */
export const flCheckIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 4.5L6.5 11.4997L3 8" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'check' as const
};